import {
    Box,
    Flex,
    HStack,
    Button,
    useColorModeValue,
    Text,
    useDisclosure,
    Stack,
    IconButton,
    Image,
    Divider,
    Spacer
} from '@chakra-ui/react';
import {
    useAuthenticator,
} from "@aws-amplify/ui-react";
import Home from "./pages/Home";
import Upload from "./pages/Upload";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import Debug from "./pages/Debug";
import Teams from "./pages/Teams";
import { Route, Routes, Navigate } from "react-router-dom";
import React from "react";
import History from './pages/History';
import SitePost from './pages/SitePost';
import ViewTeam from './pages/ViewTeam';
import Nav from './controls/NavButton';
import NavLink from './controls/NavLink';
import AnnotateImagePage from './pages/AnnotateImagePage';
import Compose from './pages/Compose';
import ViewPost from './pages/ViewPost';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import { CloseIcon, HamburgerIcon } from '@chakra-ui/icons';
import ManagePosts from './pages/ManagePosts';
import { Auth } from 'aws-amplify';
import ManageSubmissions from './pages/ManageSubmissions';
import ReviewSubmission from './pages/ReviewSubmission';
import DeleteImagePage from './pages/DeleteImagePage';

export default function useAction() {
    const { authStatus } = useAuthenticator(context => [context.authStatus]);
    const { user, signOut } = useAuthenticator((context) => [context.user]);
    const isAuthenticated = authStatus === 'authenticated';
    const { isOpen, onOpen, onClose } = useDisclosure();
    

    class UserWidget extends React.Component {
        render() {
            if (isAuthenticated) {
                return (<Flex alignItems={'center'} >
                    <Text mr={4}>{user.attributes?.given_name} {user.attributes?.family_name}</Text>
                    <Button variant={'solid'} size={'sm'} mr={4} onClick={signOut}>
                        Sign Out
                    </Button>
                </Flex>);
            } else {
                return (<Flex alignItems={'center'} >
                    {/* <Nav to="/login" text="Login to contribute" colorScheme="blue"/> */}
                    <Nav to="/login" text="Login" colorScheme="gray"/>
                </Flex>);
            }
        }
    }

    class EditorWidget extends React.Component<{isAuthenticated: boolean},{isEditor: boolean, isAdmin: boolean}> {
        constructor(props) {
            super(props);
            this.state = {
                isEditor: false,
                isAdmin: false
            }

            async function LoadData (comp) {
                const user =  await Auth.currentAuthenticatedUser();
                if (user) {
                    const groups: string[] = user.signInUserSession.accessToken.payload["cognito:groups"];
                    if (groups.includes('Admin')) {
                        comp.setState({isAdmin: true});
                    }
                    if (groups.includes('Editor')) {
                        comp.setState({isEditor: true});
                    }
                }
            }
            if (this.props.isAuthenticated) {
                LoadData(this);
            }
        }
        render() {
            var show = this.props.isAuthenticated && (this.state.isAdmin || this.state.isEditor);
            if (!show) {
                return (<></>);
            }
            
            return (<>
                <Box bg={'gray.700'} px={4} display={{ base: 'none', md: 'flex' }}>
                    <Flex h={12} alignItems={'center'} justifyContent={'space-between'}>
                        <HStack spacing={8} alignItems={'center'}>
                            <Text>Editor:</Text>
                            <HStack as={'nav'} spacing={4} display={{ base: 'none', md: 'flex' }}>
                                <NavLink key='manage-posts' to='/manage-posts' text='Manage Posts' />
                                <NavLink key='manage-submissions' to='/manage-submissions' text='Manage Submissions' />
                            </HStack>
                        </HStack>
                    </Flex>
                </Box>
                <Box bg={'gray.900'} px={4} display={{ base: 'none', md: 'flex' }}>
                </Box>
            </>);
        }
    }

    const renderNavLinks = function() : ReactJSXElement[] {
        const links: ReactJSXElement[] = [];

        links.push(<NavLink key='home' to='/' text='Home' />);
        links.push(<NavLink key='teams' to='/teams' text='Teams' />);
        links.push(<NavLink key='history' to='/history' text='History' />);
        links.push(<NavLink key='about' to='/about' text='About' />);
        links.push(<NavLink key='photo-scanning-instructions' to='/photo-scanning-instructions' text='Photo Scanning Instructions' />);
        // links.push(<NavLink key='news' to='/news' text='News' />);

        if (isAuthenticated) {
            links.push(<Nav key='upload' to="/upload-team-photo" text="Upload Team Photo" colorScheme="blue" />);
        }

        return links;
    }

    return (
        <>
            <Box bg={useColorModeValue('gray.100', 'gray.900')} px={4}>
                <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
                    <IconButton
                        size={'md'}
                        icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
                        aria-label={'Open Menu'}
                        display={{ md: 'none' }}
                        onClick={isOpen ? onClose : onOpen}
                    />
                    <HStack spacing={8} alignItems={'center'}>
                        <Image boxSize='40px' src="/logotransp64.png" />
                        <HStack as={'nav'} spacing={4} display={{ base: 'none', md: 'flex' }}>
                            {renderNavLinks()}
                        </HStack>
                    </HStack>
                    {/* <HStack spacing={8} alignItems={'center'}>
                        <Nav to="/" text="Home"/>
                        <Nav to="/teams" text="Teams"/>
                        <Nav to="/upload-team-photo" text="Upload Team Photo" colorScheme="blue"/>
                    </HStack> */}
                    <UserWidget />
                </Flex>
                {isOpen ? (
                    <Box pb={4} display={{ md: 'none' }}>
                        <Stack as={'nav'} spacing={4}>
                            {renderNavLinks()}
                        </Stack>
                    </Box>
                ) : null}
            </Box>
            <EditorWidget isAuthenticated={isAuthenticated} />
            <Routes>
                <Route path="/" element={<Home isAuthenticated={isAuthenticated} />} />
                <Route path="/login" element={isAuthenticated ? (<Navigate replace to="/" />) : (<Login />)} />
                <Route path="/upload-team-photo" element={isAuthenticated ?
                    <Box p={4}><Upload /></Box>
                    : <Login />
                }
                />
                <Route path="/teams" element={<Teams isAuthenticated={isAuthenticated}/>} />
                <Route path="/team/:id" element={<ViewTeam isAuthenticated={isAuthenticated}/>} />
                <Route path="/annotate-image/*" element={<AnnotateImagePage />} />
                <Route path="/delete-image/*" element={<DeleteImagePage />} />
                <Route path="/test" element={<div>test</div>} />
                <Route path="/compose/*" element={<Compose />} />
                <Route path="/post/*" element={<ViewPost isAuthenticated={isAuthenticated}/>} />
                <Route path="/manage-posts" element={<ManagePosts isAuthenticated={isAuthenticated} />} />
                <Route path="/manage-submissions" element={<ManageSubmissions/>} />
                <Route path="/review-submission/*" element={<ReviewSubmission/>} />

                <Route path="/history" element={<History isAuthenticated={isAuthenticated} />} />
                <Route path="/about" element={<SitePost isAuthenticated={isAuthenticated} postId='202304012' />} />
                <Route path="/photo-scanning-instructions" element={<SitePost isAuthenticated={isAuthenticated} postId='202304011' />} />

                <Route path="/debug" element={<Debug />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
            <Box bg={useColorModeValue('gray.100', 'gray.900')} px={4} >
                <Flex h={12} w='100%' alignItems={'center'} justifyContent={'space-between'}>
                    <Text fontSize='sm'>© Enfield Federal Past Players and Supporters Club 2023</Text>
                    <Spacer/>
                    <Text fontSize='sm'>Created and curated by Paul Burns & Peter Phillips</Text>
                </Flex>
            </Box>
        </>
    );
}